export default function Pagination({ currentPage, totalPages, onPageChange }) {
    // Don't render the component if there's only one page or less.
    if (totalPages <= 1) {
        return null;
    }

    const getPageItems = () => {
        const pageNeighbours = 1; // How many pages to show on each side of the current page
        const totalNumbers = (pageNeighbours * 2) + 3; // Current page + 2 neighbours + first page + last page
        const totalBlocks = totalNumbers + 2; // With two '...' blocks

        if (totalPages <= totalBlocks) {
            // If total pages is small enough, show all page numbers
            const pages = [];
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
            return pages;
        }

        const pages = [];
        const startPage = Math.max(2, currentPage - pageNeighbours);
        const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);

        // Always show the first page
        pages.push(1);

        // Show '...' if there's a gap after the first page
        if (startPage > 2) {
            pages.push('...');
        }

        // Show the pages around the current page
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        // Show '...' if there's a gap before the last page
        if (endPage < totalPages - 1) {
            pages.push('...');
        }

        // Always show the last page
        pages.push(totalPages);
        return pages;
    };
    const pageItems = getPageItems();

    return (
        <nav className="mt-6 flex justify-center relative z-10">
            <div className="inline-flex bg-white rounded-xl shadow-md border border-gray-200 p-2">
                <ul className="flex items-center space-x-1">
                    <li>
                        <button
                            onClick={() => onPageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="px-4 py-2 rounded-lg text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-gray-100 text-gray-700 hover:bg-blue-600 hover:text-white"
                        >
                            <i className="fas fa-chevron-left mr-1"></i>
                            <span className="hidden sm:inline">Previous</span>
                        </button>
                    </li>
                    {pageItems.map((item, index) => {
                        if (item === '...') {
                            return (
                                <li key={`ellipsis-${index}`}>
                                    <span className="px-3 py-2 text-gray-400">...</span>
                                </li>
                            );
                        }
                        return (
                            <li key={item}>
                                <button
                                    onClick={() => onPageChange(item)}
                                    className={`w-10 h-10 rounded-lg text-sm font-bold transition-colors ${currentPage === item ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-100 text-gray-700 hover:bg-blue-100'}`}
                                >
                                    {item}
                                </button>
                            </li>
                        );
                    })}
                    <li>
                        <button
                            onClick={() => onPageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="px-4 py-2 rounded-lg text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-gray-100 text-gray-700 hover:bg-blue-600 hover:text-white"
                        >
                            <span className="hidden sm:inline">Next</span>
                            <i className="fas fa-chevron-right ml-1"></i>
                        </button>
                    </li>
                </ul>
            </div>
        </nav>
    );
}
